import type { CursorPage } from '@/api/cursorPagination';

// Only these levels are shown in the UI and requested from the history endpoint.
export const VISIBLE_USER_LEVELS = [1, 2, 3] as const;
export type VisibleUserLevel = (typeof VISIBLE_USER_LEVELS)[number];

// One plaintext key from GET /v1/devices/{deviceId}/user-level-keys. Sensitive: never log.
export interface UserLevelKey {
  userLevel: number;
  keyValue: number;
}

// A key whose level is one the UI shows, as returned by fetchDeviceUserLevelKeys.
export type VisibleUserLevelKey = UserLevelKey & { userLevel: VisibleUserLevel };

export interface DeviceUserLevelKeysResponse {
  keys: UserLevelKey[];
}

// One past value from GET /v1/devices/{deviceId}/user-level-keys/{keyIdx}/history.
// validFrom, creatorContactId and creatorUserId are omitted when null. Sensitive: never log.
export interface UserLevelKeyHistoryEntry {
  key: number;
  validFrom?: string;
  creatorContactId?: string;
  creatorUserId?: string;
}

export type UserLevelKeyHistoryResponse = CursorPage<UserLevelKeyHistoryEntry>;
